import { lazy } from 'react'

export const ActivityDuringWorkV1 = lazy(
  () => import('./v1/ActivityDuringWorkV1'),
)
export const ActivityDuringWorkV2 = lazy(
  () => import('./v2/ActivityDuringWorkV2'),
)
